var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSports = function SvgSports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#fff",
    strokeWidth: 1.6,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.5 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M12.19 9.455 10 13.5l3.655 3.01c.155.12.265.285.33.47L15.5 22M10 13.5l-2.745 3.82c-.27.395-.78.545-1.22.36L2 16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 12h-3.5c-.18 0-.36-.045-.52-.135l-1.605-.905A19.698 19.698 0 0 0 8.89 8.57l-1.61-.285c-.225-.04-.46 0-.66.11L3.5 10"
  })));
};
export default SvgSports;